import { SecurityService } from "./_services/security.service";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule, LOCALE_ID } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { RouterModule } from "@angular/router";
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from "./app.component";
import { LoginComponent } from "./_components/login/login.component";
import { JwtAuthGuard } from "./_guards/jwt-auth.guard";
import { JwtAuthClientGuard } from "./_guards/jwt-auth-client.guard";


import "rxjs/add/operator/map";
import "rxjs/add/operator/debounceTime";

import { MyDatePickerModule } from "mydatepicker";

//Toast
import { ToastNotificationComponent } from "./_components/toast-notification/toast-notification.component";
import { ToastService } from "./_services/toast.service";

// Date Service (Used to format dates inputs values)
import { DateService } from "./_services/date.service";

// Contacts
import { ContactService } from "./_services/contact.service";
import { ContactComponent } from "./_components/contact/contact.component";
import { NewContactComponent } from "./_components/contact/new-contact/new-contact.component";
import { EditContactComponent } from "./_components/contact/edit-contact/edit-contact.component";
import { DeleteContactComponent } from "./_components/contact/delete-contact/delete-contact.component";

// Companies
import { CompanyService } from "./_services/company.service";
import { CompanyComponent } from "./_components/company/company.component";
import { NewCompanyComponent } from "./_components/company/new-company/new-company.component";
import { EditCompanyComponent } from "./_components/company/edit-company/edit-company.component";
import { DeleteCompanyComponent } from "./_components/company/delete-company/delete-company.component";
import { CompanyAutocompleteComponent } from "./_components/company-autocomplete/company-autocomplete.component";

// Company Modal
import { CompanyModalComponent } from "./_components/company-modal/company-modal.component";
import { CompanyContactsComponent } from "./_components/company-modal/company-contacts/company-contacts.component";

// Demands
import { DemandService } from "./_services/demand.service";
import { DemandComponent } from "./_components/demand/demand.component";
import { NewDemandComponent } from "./_components/demand/new-demand/new-demand.component";
import { EditDemandComponent } from "./_components/demand/edit-demand/edit-demand.component";
import { DeleteDemandComponent } from "./_components/demand/delete-demand/delete-demand.component";
//
import { SendDemandsModalComponent } from "./_components/send-demands-modal/send-demands-modal.component";

// Places (Cities, Areas, Countries..)
import { PlaceService } from "./_services/place.service";
import { CityAutocompleteComponent } from "./_components/city-autocomplete/city-autocomplete.component";
import { AreaAutocompleteComponent } from "./_components/area-autocomplete/area-autocomplete.component";
import { CountryAutocompleteComponent } from "./_components/country-autocomplete/country-autocomplete.component";
// Offers
import { OfferService } from "./_services/offer.service";
import { OfferComponent } from "./_components/offer/offer.component";
import { OfferTableComponent } from "./_components/offer/offer-table/offer-table.component";
import { OfferPlanningService } from "./_services/offer-planning.service";

import { NewOfferComponent } from "./_components/offer/new-offer/new-offer.component";
import { DeleteOfferComponent } from "./_components/offer/delete-offer/delete-offer.component";
import { EditOfferComponent } from "./_components/offer/edit-offer/edit-offer.component";
import { NewCityModalComponent } from "./_components/new-city-modal/new-city-modal.component";
import { MatchingOffersModalComponent } from "./_components/matching-offers-modal/matching-offers-modal.component";
import { CompanyRatingComponent } from "./_components/company-rating/company-rating.component";
import { VehicleSelectComponent } from "./_components/vehicle-select/vehicle-select.component";
import { QuantityFilterComponent } from "./_components/quantity-filter/quantity-filter.component";
import { MatchingDemandsModalComponent } from "./_components/matching-demands-modal/matching-demands-modal.component";
import { PriceFilterComponent } from "./_components/price-filter/price-filter.component";
import { CompanyDemandsComponent } from "./_components/company-modal/company-demands/company-demands.component";
import { CompanyOffersComponent } from "./_components/company-modal/company-offers/company-offers.component";

// Planning
import { PlanningComponent } from "./_components/planning/planning.component";
import { PlanningModalComponent } from "./_components/planning/planning-modal/planning-modal.component";
import { NewPlanningComponent } from "./_components/planning/new-planning/new-planning.component";
import { DeletePlanningComponent } from "./_components/planning/delete-planning/delete-planning.component";
import { PlanningService } from "./_services/planning.service";
import { TaskListComponent } from "./_components/task-list/task-list.component";
import { TaskListService } from "./_services/task-list.service";
import { IncidentListComponent } from "./_components/incident-list/incident-list.component";
import { IncidentListService } from "./_services/incident-list.service";

import { TransportHistoryComponent } from "./_components/transport-history/transport-history.component";
import { HistoryTableComponent } from "./_components/transport-history/history-table/history-table.component";
import { TransportHistoryService } from "./_services/transport-history.service";
import { HttpClientModule } from "@angular/common/http";
import { TransportDetailsComponent } from "./_components/transport-details/transport-details.component";
import { TransportDetailsService } from "./_services/transport-details.service";
import { PlanningFilesService } from "./_services/planning-files.service";
import { PlanningMessagesService } from "./_services/planning-messages.service";
import { PlanningChatModalComponent } from "./_components/planning/planning-chat-modal/planning-chat-modal.component";
import { PlanningConfirmTransportService } from "./_services/planning-confirm-transport.service";
//planning palettes
import { PlanningPalettesService } from "./_services/planning-palettes.service";


import { DeliveryDetailsComponent } from "./_components/delivery-details/delivery-details.component";
import { DeliveryDetailsService } from "./_services/delivery-details.service";


//espace client
import { ClientService } from "./_services/client.service";
import { ClientComponent } from "./_components/client/client.component";
import { ClientPlanningModalComponent } from "./_components/client/client-planning-modal/client-planning-modal.component";
import { ClientDashboardComponent } from "./_components/client/client-dashboard/client-dashboard.component";
import { ClientPlanningFilesModalComponent } from "./_components/client/client-planning-files-modal/client-planning-files-modal.component";
import { ClientPlanningConfirmTransportModalComponent } from "./_components/client/client-planning-confirm-transport-modal/client-planning-confirm-transport-modal.component";

//demande de transport (planning) par le client
import { ClientNewPlanningComponent } from "./_components/client/client-new-planning/client-new-planning.component";
//page geofret pour repondre à la demande de transport (planning)
import { ClientPlanningCreationComponent } from "./_components/client-planning-creation/client-planning-creation.component";
//client tasks
import { ClientTasksComponent } from "./_components/client/client-tasks/client-tasks.component";
import { ClientIncidentsComponent } from "./_components/client/client-incidents/client-incidents.component";

//users 
import { UserService } from "./_services/user.service";
import { UserComponent } from "./_components/user/user.component";
import { NewUserComponent } from "./_components/user/new-user/new-user.component";
import { DeleteUserComponent } from "./_components/user/delete-user/delete-user.component";
import { ClientPlanningCreationService } from "./_services/client-planning-creation.service";

import { DashboardComponent } from "./_components/dashboard/dashboard.component";

//gestion des villes
import { CityService } from "./_services/city.service";
import { AreaService } from "./_services/area.service";
import { CityComponent } from "./_components/city/city.component";
import { DeleteCityComponent } from "./_components/city/delete-city/delete-city.component";
import { EditCityComponent } from "./_components/city/edit-city/edit-city.component";

//import { AreaComponent } from "./_components/area/area.component";


//entrepots
import { WarehouseService } from "./_services/warehouse.service";
import { WarehouseComponent } from "./_components/warehouse/warehouse.component";
import { NewWarehouseComponent } from "./_components/warehouse/new-warehouse/new-warehouse.component";
import { EditWarehouseComponent } from "./_components/warehouse/edit-warehouse/edit-warehouse.component";
import { DeleteWarehouseComponent } from "./_components/warehouse/delete-warehouse/delete-warehouse.component";
import { WarehouseAutocompleteComponent } from "./_components/warehouse-autocomplete/warehouse-autocomplete.component";
import { WarehouseModalComponent } from "./_components/warehouse-modal/warehouse-modal.component";
//transporteur
import { TransporteurComponent } from './_components/transporteur/transporteur.component';
import { TransporteurService } from './_services/transporteur.service';
import { GoogleMapsLoaderService } from './_services/google-maps-loader.service';

//nav
import { NavigationService } from "./_services/navigation.service";
import { NavigationComponent } from './_components/navigation/navigation.component';


//page not found
import { PageNotFoundComponent } from "./_components/page-not-found/page-not-found.component";
//devis
import { DevisComponent } from './_components/devis/devis.component';
import { DevisService } from "./_services/devis.service";
import { DevisFilesService } from "./_services/devis-files.service";
import { FileUploadService } from "./_services/FileUploadService";


//config
import { ConfigComponent } from './_components/config/config.component';
import { ConfigService } from './_services/config.service';
import { DistanceService } from "./_services/distanceService";

import { Co2Service } from './_services/co2.service';

//transport interest
import { TransportInterestService } from './_services/transport-interest.service';
import { TransportInterestComponent } from './_components/transport-interest/transport-interest.component';

//export
import { ExportService } from './_services/export.service';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    UserComponent,
    NewUserComponent,
    DeleteUserComponent,
    ClientComponent,
    ClientNewPlanningComponent,
    ClientTasksComponent,
    ClientIncidentsComponent,
    ClientPlanningModalComponent,
    ClientDashboardComponent,
    ClientPlanningFilesModalComponent,
    ClientPlanningConfirmTransportModalComponent,
    ContactComponent,
    NewContactComponent,
    DeleteContactComponent,
    CompanyModalComponent,
    CompanyContactsComponent,
    ToastNotificationComponent,
    EditContactComponent,
    CompanyComponent,
    NewCompanyComponent,
    DeleteCompanyComponent,
    EditCompanyComponent,
    DemandComponent,
    NewDemandComponent,
    DeleteDemandComponent,
    EditDemandComponent,
    SendDemandsModalComponent,
    CompanyAutocompleteComponent,
    OfferComponent,
    OfferTableComponent,
    NewOfferComponent,
    DeleteOfferComponent,
    EditOfferComponent,
    CityAutocompleteComponent,
    AreaAutocompleteComponent,
    CountryAutocompleteComponent,
    NewCityModalComponent,
    MatchingOffersModalComponent,
    CompanyRatingComponent,
    VehicleSelectComponent,
    QuantityFilterComponent,
    MatchingDemandsModalComponent,
    PriceFilterComponent,
    CompanyDemandsComponent,
    CompanyOffersComponent,
    PlanningComponent,
    PlanningModalComponent,
    PlanningChatModalComponent,
    TaskListComponent,
    IncidentListComponent,
    NewPlanningComponent,
    DeletePlanningComponent,
    TransportHistoryComponent,
    HistoryTableComponent,
    TransportDetailsComponent,
    DeliveryDetailsComponent,
    ClientPlanningCreationComponent,
    DashboardComponent,
    CityComponent,
    DeleteCityComponent,
    EditCityComponent,
    WarehouseComponent,
    NewWarehouseComponent,
    EditWarehouseComponent,
    DeleteWarehouseComponent,
    WarehouseAutocompleteComponent,
    WarehouseModalComponent,
    TransporteurComponent,
    PageNotFoundComponent,
    NavigationComponent,
    DevisComponent,
    ConfigComponent,
    TransportInterestComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule,
    AppRoutingModule,
    HttpModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MyDatePickerModule,
    
  ],
  providers: [
    SecurityService,
    ToastService,
    ClientService,
    ContactService,
    CompanyService,
    DemandService,
    OfferService,
    PlaceService,
    DateService,
    PlanningService,
    TaskListService,
    IncidentListService,
    TransportHistoryService,
    TransportDetailsService,
    DeliveryDetailsService,
    ClientPlanningCreationService,
    OfferPlanningService,
    UserService,
    PlanningFilesService,
    FileUploadService,
    PlanningMessagesService,
    PlanningConfirmTransportService,
    PlanningPalettesService,
    WarehouseService,
    CityService,
    AreaService,
    GoogleMapsLoaderService,
    TransporteurService,
    NavigationService,
    DevisService,
    DevisFilesService,
    ConfigService,
    DistanceService,
    Co2Service,
    TransportInterestService,
    ExportService,
    { provide: LOCALE_ID, useValue: "fr-FR" },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// /usr/src/app/src/app/app.module.ts